import type { IApiResponse } from './interfaces/IApiResponse'
import { PageEnum, parsePageEnum } from '@nami/domain/enums'
import useAxios from './composables/useAxios'

function pageEnumToString(page: PageEnum): string {
    return PageEnum[page].toLowerCase()
}

export const pageAccessApi = async (
    page: PageEnum,
    isSkipAddBankAccount: boolean,
): Promise<{ isOk: boolean, page: PageEnum }> => {
    const pageName = pageEnumToString(page)
    const response: IApiResponse<any> = await useAxios.get(
        `/validate/${pageName}?isSkipAddBankAccount=${isSkipAddBankAccount}`,
    )

    const targetPage = parsePageEnum(response.data.data.target)

    return {
        isOk: response.data.data.target.toLowerCase() === pageName,
        page: targetPage,
    }
}
